// Carrito: confirmar cantidades y guardar el DNI / NIE / NIF de la factura (obligatorio en pedidos de más de 3.000 € IVA incluido).
(() => {
  if (window.MPCartGuards) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const number = value => new Intl.NumberFormat('es-ES', { maximumFractionDigits: 2 }).format(value);
  let busy = false, reloaded = false, allowedSubmit = null;
  // Peticiones que cambian el carrito (las de Prestige, las de otros scripts y las nuestras) mientras
  // viajan: antes de comprobar el carrito y de ir al pago se espera a que terminen. Así una cantidad
  // cambiada justo antes de «Finalizar compra» nunca se valida con el carrito anterior.
  const pendingCart = new Set();
  let cartMutations = 0;
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url || String(input || '');
    const promise = nativeFetch.apply(window, arguments);
    if (/\/cart\/(change|update|add|clear)(\.js)?([?#]|$)/.test(url)) {
      cartMutations++;
      let tracked;
      const done = () => { pendingCart.delete(tracked); };
      tracked = promise.then(done, done);
      pendingCart.add(tracked);
    }
    return promise;
  };
  const cartIdle = async (timeout = 15000) => {
    const deadline = Date.now() + timeout;
    while (pendingCart.size) {
      if (Date.now() > deadline) return false;
      await Promise.race([Promise.allSettled([...pendingCart]), new Promise(resolve => setTimeout(resolve, 250))]);
    }
    return true;
  };
  let invoiceDraft = null, invoiceSaving = null;
  // Umbral en céntimos sin IVA tal como los da /cart.js (247935 = más de 3.000 € con IVA); lo fija el snippet.
  const threshold = () => {
    const value = Number(document.querySelector('mp-cart-invoice')?.dataset.threshold);
    return Number.isFinite(value) ? value : 0;
  };
  const normalizeNif = value => String(value || '').toUpperCase().replace(/[\s-]/g, '');
  const validNif = value => {
    const nif = normalizeNif(value), letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    if (/^\d{8}[A-Z]$/.test(nif)) return letters[Number(nif.slice(0, 8)) % 23] === nif[8];
    if (/^[XYZ]\d{7}[A-Z]$/.test(nif)) return letters[Number('XYZ'.indexOf(nif[0]) + nif.slice(1, 8)) % 23] === nif[8];
    if (!/^[ABCDEFGHJNPQRSUVW]\d{7}[0-9A-J]$/.test(nif)) return false;
    let sum = 0;
    for (let i = 1; i <= 7; i++) {
      const digit = Number(nif[i]);
      const part = i % 2 ? digit * 2 : digit;
      sum += Math.floor(part / 10) + part % 10;
    }
    const control = (10 - sum % 10) % 10;
    if ('ABEH'.includes(nif[0])) return nif[8] === String(control);
    if ('NPQRSW'.includes(nif[0])) return nif[8] === 'JABCDEFGHI'[control];
    return nif[8] === String(control) || nif[8] === 'JABCDEFGHI'[control];
  };
  const invoiceError = (text, target) => {
    document.querySelectorAll('mp-cart-invoice').forEach(panel => {
      const error = panel.querySelector('[data-mp-invoice-error]');
      error.textContent = text; error.hidden = !text;
      panel.querySelector('[data-mp-invoice-input]').setAttribute('aria-invalid', String(Boolean(text)));
    });
    if (text) (target?.form?.querySelector('[data-mp-invoice-input]') || target)?.focus();
  };
  const syncInvoice = cart => document.querySelectorAll('mp-cart-invoice').forEach(panel => {
    const required = cart.total_price >= threshold(), input = panel.querySelector('[data-mp-invoice-input]');
    panel.dataset.totalPrice = String(cart.total_price);
    panel.hidden = !required; input.required = required; input.disabled = !required;
    input.value = invoiceDraft ?? normalizeNif(cart.attributes?.['DNI/NIF']);
    const saved = validNif(input.value) && cart.attributes?.['DNI/NIF'] === input.value;
    panel.querySelector('[data-mp-invoice-status]').textContent = saved ? 'DNI / NIE / NIF guardado para la factura.' : '';
    if (!required) invoiceError('');
  });
  const saveNif = async value => {
    const response = await fetch(`${root()}cart/update.js`, { method: 'POST', headers,
      body: JSON.stringify({ attributes: { 'DNI/NIF': value } }) });
    if (!response.ok) throw new Error('update.js');
    const cart = await response.json();
    if (cart.attributes?.['DNI/NIF'] !== value) throw new Error('NIF no guardado');
    return cart;
  };
  const verifyInvoice = async (cart, target) => {
    syncInvoice(cart);
    if (cart.total_price < threshold()) return true;
    const value = invoiceDraft ?? normalizeNif(cart.attributes?.['DNI/NIF']);
    if (!validNif(value)) {
      invoiceError('Introduce un DNI, NIE o NIF válido: revisa el formato y la letra o el dígito de control.', target);
      return false;
    }
    if (cart.attributes?.['DNI/NIF'] !== value) await saveNif(value);
    // Se comprueba el atributo persistido, nunca solo el valor escrito en el campo.
    const saved = await readCart();
    syncInvoice(saved);
    if (saved.items.map(item => inspect(item, saved.items)).some(line => line.mismatch || line.incomplete)) throw new Error('Carrito modificado');
    if (saved.total_price < threshold()) return true;
    if (invoiceDraft !== null && invoiceDraft !== value) {
      invoiceError('Has cambiado el DNI / NIE / NIF. Pulsa Finalizar compra para comprobarlo y guardarlo.', target);
      return false;
    }
    return validNif(saved.attributes?.['DNI/NIF']) && saved.attributes['DNI/NIF'] === value;
  };
  const metadata = new Map();
  const collectMetadata = () => document.querySelectorAll('mp-calculator-line, mp-box-line').forEach(marker => {
    const info = { ...marker.dataset };
    metadata.set(info.key, info);
    if (info.variantId) metadata.set(`variant:${info.variantId}`, info);
  });
  const infoFor = item => metadata.get(item.key) || metadata.get(`variant:${item.variant_id}`) || {};
  const inspect = (item, items = [item]) => {
    const props = item.properties || {}, info = infoFor(item);
    const mode = props._piezas != null ? 'ml' : props._cajas != null ? 'm2' : null;
    const expected = Number(props[mode === 'ml' ? '_piezas' : '_cajas']);
    const size = Math.max(1, Number(info.boxSize) || 1);
    const quantity = Number(item.quantity);
    const total = items.filter(line => line.variant_id === item.variant_id).reduce((sum, line) => sum + Number(line.quantity), 0);
    return { item, mode, expected, quantity, total, size, unitType: info.unitType, unitSize: Number(info.unitSize) || 0,
      requested: props[mode === 'ml' ? '_ml_solicitados' : '_m2_solicitados'],
      mismatch: Boolean(mode) && (!Number.isInteger(expected) || expected < 1 || expected !== quantity),
      incomplete: size > 1 && (total < size || total % size !== 0) };
  };
  const quantityText = (line, quantity) => line.size > 1
    ? `${quantity / line.size} caja${quantity / line.size === 1 ? '' : 's'} (${quantity} tiras)`
    : line.unitType === 'm2' ? `${quantity} m²` : line.unitType === 'roll-meter' ? `${quantity} m de rollo`
    : line.unitType === 'roll' ? `${quantity} rollo${quantity === 1 ? '' : 's'}`
    : line.unitType === 'pack' ? `${quantity} pack${quantity === 1 ? '' : 's'} A+B (${quantity * 2} cajas)`
    : `${quantity} ${line.mode === 'ml' ? (quantity === 1 ? 'pieza' : 'piezas') : (quantity === 1 ? 'caja' : 'cajas')}`;
  const restoreQuantity = line => Math.max(1, Math.ceil((line.total - line.quantity + line.expected) / line.size)) * line.size - (line.total - line.quantity);
  const message = line => {
    const from = line.requested ? `Para tus ${line.requested} ${line.mode === 'ml' ? 'ml' : 'm²'} calculamos` : 'La calculadora indicó';
    const coverage = line.unitSize ? ` (cubre ${number(line.quantity * line.unitSize)} ${line.mode === 'ml' ? 'ml' : 'm²'})` : '';
    const waste = line.item.properties?._merma_pct ? ` El cálculo incluye ${line.item.properties._merma_pct} % de merma.` : '';
    return `${from} ${quantityText(line, line.expected)} y tienes ${quantityText(line, line.quantity)}${coverage}.${waste}`;
  };
  const notice = text => {
    let status = document.querySelector('[data-mp-cart-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-mp-cart-status', ''); status.setAttribute('role', 'status');
      status.className = 'mp-cart-warning text-sm';
      Object.assign(status.style, { position: 'fixed', bottom: '16px', left: '16px', right: '16px', zIndex: '100' });
      status.addEventListener('click', () => status.remove());
      document.body.append(status);
    }
    status.textContent = text;
  };
  const readCart = async () => {
    const response = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('cart.js');
    const cart = await response.json();
    if (!Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) throw new Error('Carrito inválido');
    return cart;
  };
  const sectionIds = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    const page = document.querySelector('.cart-page')?.closest('.shopify-section');
    if (page) sections.push(page.id.replace('shopify-section-', ''));
    return [...new Set(sections)];
  };
  const refresh = cart => {
    const page = document.querySelector('.cart-page')?.closest('.shopify-section');
    if (page) {
      const html = cart.sections?.[page.id.replace('shopify-section-', '')];
      const replacement = html && new DOMParser().parseFromString(html, 'text/html').getElementById(page.id);
      if (replacement) page.replaceChildren(...replacement.childNodes);
      else if (!reloaded) { reloaded = true; window.location.reload(); }
    }
    // Prestige sustituye el cajón con las secciones agrupadas.
    if (cart.sections && Object.values(cart.sections).every(html => typeof html === 'string')) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart } }));
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
    collectMetadata();
    syncInvoice(cart);
  };
  const acceptedProperties = line => {
    const properties = { ...line.item.properties };
    delete properties._m2_solicitados; delete properties._ml_solicitados; delete properties._merma_pct;
    properties[line.mode === 'ml' ? '_piezas' : '_cajas'] = String(line.quantity);
    if (line.size > 1) properties._cajas = String(line.quantity / line.size);
    properties._ajuste_cliente = 'sí';
    return window.MPLineQuantity ? window.MPLineQuantity.properties(properties, line.quantity, line) : properties;
  };
  const changeLine = async (line, keep = false) => {
    if (keep && line.incomplete) throw new Error('Caja incompleta');
    const quantity = keep ? line.quantity : restoreQuantity(line);
    if (!Number.isInteger(quantity) || quantity < 1) throw new Error('Cantidad inválida');
    let properties = keep ? acceptedProperties(line) : quantity !== line.expected
      ? { ...line.item.properties, _piezas: String(quantity), _cajas: String(quantity / line.size) } : undefined;
    if (window.MPLineQuantity) properties = window.MPLineQuantity.properties(properties || line.item.properties, quantity, line, true);
    const response = await fetch(`${root()}cart/change.js`, { method: 'POST', headers,
      body: JSON.stringify({ id: line.item.key, quantity, ...(properties ? { properties } : {}), sections: sectionIds().join(',') }) });
    if (!response.ok) throw new Error('change.js');
    const cart = await response.json();
    const updated = cart.items?.find(item => properties
      ? item.variant_id === line.item.variant_id && Object.keys(properties).every(key => item.properties?.[key] === properties[key])
        && (!keep || (!item.properties?._m2_solicitados && !item.properties?._ml_solicitados && !item.properties?._merma_pct))
      : item.key === line.item.key);
    if (!updated || updated.quantity !== quantity || inspect(updated, cart.items).incomplete) throw new Error('Cantidad no confirmada');
    metadata.set(updated.key, infoFor(line.item));
    refresh(cart);
    return cart;
  };
  const choose = line => new Promise(resolve => {
    const dialog = document.createElement('dialog');
    dialog.className = 'mp-cart-dialog'; dialog.setAttribute('aria-labelledby', 'mp-cart-dialog-title');
    dialog.innerHTML = '<h2 id="mp-cart-dialog-title" class="h5">Revisa la cantidad</h2><p class="text-sm" data-message></p><div class="mp-cart-dialog__actions"><button type="button" class="button" data-restore></button><button type="button" class="button button--outline" data-keep></button><button type="button" class="link" data-close>Volver al carrito</button></div>';
    dialog.querySelector('[data-message]').textContent = message(line);
    const restore = dialog.querySelector('[data-restore]'), keep = dialog.querySelector('[data-keep]');
    restore.textContent = `Poner ${quantityText(line, restoreQuantity(line))}`;
    restore.disabled = !Number.isInteger(line.expected) || line.expected < 1;
    keep.textContent = `${line.quantity < line.expected ? 'Quiero solo' : 'Quiero'} ${quantityText(line, line.quantity)}`;
    keep.disabled = line.incomplete;
    const finish = choice => { dialog.close(); dialog.remove(); resolve(choice); };
    restore.addEventListener('click', () => finish('restore'));
    keep.addEventListener('click', () => finish('keep'));
    dialog.querySelector('[data-close]').addEventListener('click', () => finish(null));
    dialog.addEventListener('cancel', event => { event.preventDefault(); finish(null); });
    document.body.append(dialog); dialog.showModal();
  });
  const check = async target => {
    if (invoiceSaving) await invoiceSaving.catch(() => {});
    if (busy) { notice('Espera a que termine la actualización del carrito.'); return; }
    busy = true;
    const selector = target.closest('cart-drawer') ? 'cart-drawer [name="checkout"]' : '.cart-page [name="checkout"]';
    try {
      const input = target.form?.querySelector('[data-mp-invoice-input]');
      if (input && !input.disabled) invoiceDraft = normalizeNif(input.value);
      if (!await cartIdle()) { notice('El carrito aún se está actualizando. Espera un momento y vuelve a pulsar Finalizar compra.'); return; }
      collectMetadata();
      let cart = await readCart();
      document.querySelector('[data-mp-cart-status]')?.remove();
      // Varias líneas se confirman en serie; nunca se reintenta una respuesta rechazada.
      for (let remaining = cart.items.length; remaining >= 0; remaining--) {
        const lines = cart.items.map(item => inspect(item, cart.items));
        if (lines.some(line => line.incomplete)) { notice('Revisa las cajas completas del producto antes de continuar.'); return; }
        const line = lines.find(line => line.mismatch);
        if (!line) break;
        if (!remaining) throw new Error('Líneas sin confirmar');
        const choice = await choose(line);
        if (!choice) return;
        await changeLine(line, choice === 'keep');
        cart = await readCart();
      }
      if (!await verifyInvoice(cart, target)) return;
      if (reloaded) return;
      if (window.mpEntregaCart) await window.mpEntregaCart.save();
      // Última comprobación: se repite hasta que ninguna petición al carrito haya empezado ni siga en
      // curso desde la lectura validada. Entre esa comprobación y el envío no hay ningún await.
      let validated = false;
      for (let round = 0; round < 3 && !validated; round++) {
        if (!await cartIdle()) { notice('El carrito aún se está actualizando. Espera un momento y vuelve a pulsar Finalizar compra.'); return; }
        const generation = cartMutations;
        const finalCart = await readCart();
        if (finalCart.items.map(item => inspect(item, finalCart.items)).some(line => line.mismatch || line.incomplete)) {
          notice('El carrito acaba de cambiar: revisa las cantidades y vuelve a pulsar Finalizar compra.'); return;
        }
        if (!(await verifyInvoice(finalCart, target))) return;
        validated = cartMutations === generation && pendingCart.size === 0;
      }
      if (!validated) { notice('El carrito aún se está actualizando. Espera un momento y vuelve a pulsar Finalizar compra.'); return; }
      const button = document.querySelector(selector) || target;
      if (!button.isConnected || button.disabled) return;
      allowedSubmit = button;
      // Las cantidades ya están guardadas y comprobadas por clave: el POST final no reenvía los
      // updates[] del formulario (cada línea pinta dos selectores y Shopify los asigna por posición).
      const quantityFields = [...(button.form.elements || [])].filter(field => field.name === 'updates[]' && !field.disabled);
      quantityFields.forEach(field => { field.disabled = true; });
      try { button.form.requestSubmit(button); }
      finally { quantityFields.forEach(field => { field.disabled = false; }); }
      allowedSubmit = null;
    } catch (error) {
      notice('No se ha podido verificar o guardar el carrito y el DNI / NIE / NIF. Inténtalo de nuevo antes de finalizar la compra.');
    } finally { busy = false; allowedSubmit = null; }
  };
  const guardCheckout = event => {
    const target = event.type === 'submit'
      ? (event.submitter ? (event.submitter.matches('[name="checkout"]') ? event.submitter : null) : event.target.querySelector('[name="checkout"]'))
      : event.target.closest('[name="checkout"]');
    if (!target) return;
    if (event.type === 'submit' && target === allowedSubmit) {
      document.documentElement.dispatchEvent(new CustomEvent('mp:checkout-approved', { bubbles: true }));
      return;
    }
    event.preventDefault(); event.stopImmediatePropagation();
    check(target);
  };
  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', guardCheckout, true);
  const guardQuantity = event => {
    if (!busy || !event.target.closest('line-item-quantity')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (event.type === 'change') event.target.value = event.target.defaultValue;
    notice('Espera a que termine la revisión del carrito.');
  };
  document.addEventListener('click', guardQuantity, true);
  document.addEventListener('change', guardQuantity, true);
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-mp-invoice-input]')) return;
    invoiceDraft = normalizeNif(event.target.value);
    document.querySelectorAll('[data-mp-invoice-input]').forEach(input => { input.value = invoiceDraft; });
    invoiceError('');
    document.querySelectorAll('[data-mp-invoice-status]').forEach(status => { status.textContent = ''; });
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-mp-invoice-input]') || busy) return;
    invoiceDraft = normalizeNif(event.target.value);
    // Al salir del campo pulsando «Finalizar compra», el clic espera a este guardado en vez de rechazarse.
    invoiceSaving = saveInvoiceField(event).finally(() => { invoiceSaving = null; });
  });
  const saveInvoiceField = async event => {
    try {
      const cart = await readCart();
      syncInvoice(cart);
      if (cart.total_price < threshold()) return;
      if (!validNif(invoiceDraft)) {
        invoiceError('Introduce un DNI, NIE o NIF válido: revisa el formato y la letra o el dígito de control.', event.target);
        return;
      }
      const value = invoiceDraft;
      const saved = await saveNif(value);
      syncInvoice(saved);
    } catch (error) { invoiceError('No se ha podido guardar el DNI / NIE / NIF. Inténtalo de nuevo antes de finalizar la compra.', event.target); }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-mp-calculator-restore]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    try {
      collectMetadata();
      const cart = await readCart(), key = button.closest('mp-calculator-line').dataset.key;
      const item = cart.items.find(item => item.key === key);
      if (!item) throw new Error('Línea antigua');
      await changeLine(inspect(item, cart.items));
    } catch (error) { notice('No se ha podido ajustar la cantidad. Inténtalo de nuevo.'); }
    finally { busy = false; }
  }, true);
  document.addEventListener('cart:change', event => syncInvoice(event.detail.cart));
  const invoiceReady = () => document.querySelectorAll('mp-cart-invoice').forEach(panel => {
    syncInvoice({ total_price: Number(panel.dataset.totalPrice), attributes: { 'DNI/NIF': panel.querySelector('[data-mp-invoice-input]').value } });
  });
  customElements.define('mp-cart-invoice', class extends HTMLElement {
    connectedCallback() {
      // El cajón AJAX conserva el texto aún no guardado.
      const input = this.querySelector('[data-mp-invoice-input]');
      if (invoiceDraft !== null) input.value = invoiceDraft;
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', invoiceReady, { once: true });
  else invoiceReady();
  window.MPCartGuards = { inspect, acceptedProperties, changeLine, check, normalizeNif, validNif };
})();
